import {
    SET_NOTIFICATION,
    FETCH_NOTIFICATION_ALL_LIST,
    FETCH_NOTIFICATION_COUNT_OF_UNREAD,
    FETCH_NOTIFICATION_MARK_READ,
    SET_USER_MENU,
} from 'store/key';
import { call, put, takeLeading, select } from 'redux-saga/effects';
import api from 'api/notification';
import { produce } from 'utility/general';
import { safeSaga } from 'store';

const initialState = { data: [], unReadCount: null, list: [], page: 0, pageSize: 20, hasNext: true };

function* getNotificationList(action) {
    const { callback } = action.payload;
    const { notification } = yield select();
    const { list, page, pageSize, hasNext } = notification;
    try {
        if (!hasNext) return;
        const response = yield call(api.getNotifications, { page: page + 1, pageSize });

        const { result } = response.data;
        const data = result.data || [];
        callback && callback();
        yield put({
            type: SET_NOTIFICATION,
            payload: { list: [...list, ...data], page: result.page, hasNext: result.hasNext },
        });
    } catch (error) {
        console.log('reducer.js error', error);
    }
}
function* getNotificationCountOfUnRead(action) {
    try {
        const response = yield call(api.getNotificationsCountOfUnread);
        const { result } = response.data;
        // yield put({ type: SET_USER_MENU, payload: { data: formattedData, isLoading: false } });
        yield put({ type: SET_NOTIFICATION, payload: { unReadCount: result } });
    } catch (error) {
        console.log('reducer.js error', error);
    }
}
function* postNotificationMarkRead(action) {
    const { id, markAll, index } = action.payload;
    const { notification } = yield select();
    const { list } = notification;
    try {
        yield call(api.postNotificationMarkRead, { id, markAll });

        // yield getNotificatindexionList({
        //     payload: {  },
        // });
        if (index || index === 0) {
            list[index].read = true;
        } else {
            list.forEach((item, i) => {
                list[i].read = true;
            });
        }
        yield getNotificationCountOfUnRead({
            payload: {},
        });
        yield put({ type: SET_USER_MENU, payload: { list: list } });
    } catch (error) {
        console.log('reducer.js error', error);
    }
}

export const updateNotification = (data) => ({
    type: SET_NOTIFICATION,
    payload: { commentDialog: data },
});

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_NOTIFICATION:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};

export function* watchNotification() {
    yield takeLeading(FETCH_NOTIFICATION_ALL_LIST, safeSaga(getNotificationList));
    yield takeLeading(FETCH_NOTIFICATION_COUNT_OF_UNREAD, safeSaga(getNotificationCountOfUnRead));
    yield takeLeading(FETCH_NOTIFICATION_MARK_READ, safeSaga(postNotificationMarkRead));
}

export default reducer;
